











































// このコンポーネントは実装上の理由から Input.vue と意図的に分離されている
// Input.vue のデザインを変更した際は Password.vue にも同様の変更を反映すること
// SEE: https://github.com/Everforth/growthpalette-front/pull/8950
import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Inject, Prop } from 'vue-property-decorator'

@Component
export default class Password extends Vue {
  @Inject()
  $validator: Validator

  @Prop({ default: null })
  priorValidator: Validator

  @Prop()
  value

  @Prop()
  label: string

  @Prop({ required: true })
  name: string

  @Prop()
  htmlClass: any

  @Prop()
  placeholder: string

  @Prop()
  autocomplete: string

  @Prop({ default: false })
  disabled: boolean

  @Prop()
  hasDependencies: boolean

  isPasswordVisible: boolean = false

  get effectiveType(): string {
    return this.isPasswordVisible ? 'text' : 'password'
  }

  hasError(): boolean {
    if (this.hasDependencies) {
      return this.validator.errors.has(this.name) && this.isTouched(this.name)
    }

    return this.validator.errors.has(this.name)
  }

  getErrorMessage(): string {
    return this.validator.errors.first(this.name)
  }

  get validator(): Validator {
    return this.priorValidator || this.$validator
  }

  get _class() {
    return {
      'c-input': true,
      'form-control': true,
      'form-control-sm': true,
      'is-invalid': this.hasError(),
      ...this.htmlClass,
    }
  }

  private isTouched(name: string): boolean {
    const field = this.validator.fields.find({ name })

    if (!field) {
      return true
    }

    return field.flags.touched
  }
}
